export enum FieldType {
  TEXT = 'TEXT',
  MULTI_TEXT = 'MULTI_TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  TEXTAREA = 'TEXTAREA',
  RATING = 'RATING',
  MULTI_FIELD = 'MULTI_FIELD',
  PREDEFINED = 'PREDEFINED',
  SIGNATURE = 'SIGNATURE',
  SECTION_SCORE = 'SECTION_SCORE'
}

export enum PredefinedFieldType {
  NAME = 'NAME',
  EMAIL = 'EMAIL',
  DEPARTMENT = 'DEPARTMENT',
  FACULTY = 'FACULTY',
  PHONE = 'PHONE',
  INSTITUTIONAL_EMAIL = 'INSTITUTIONAL_EMAIL',
  SIGNATURE = 'SIGNATURE',
  USER_ID = 'USER_ID'
}

export enum SectionStatus {
  PENDING = 'PENDING',
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED'
}

export interface FieldOption {
  id?: string;
  value: string;
  label: string;
  score?: number;
  displayOrder: number;
  requiredAggregate?: number;
}

export interface SubField {
  hint: string;
  id?: string;
  name: string;
  label: string;
  fieldType: FieldType;
  required: boolean;
  displayOrder: number;
  minLength?: number;
  maxLength?: number;
  minValue?: number;
  maxValue?: number;
  stepValue?: number;
  minRating?: number; 
  maxRating?: number;
  minDate?: string;
  maxDate?: string;
  options?: FieldOption[];
}

export interface MultiFieldValueDTO {
  id: string;
  subFieldValues: Record<string, any>;
  displayOrder?: number;
  label?: string;
}

export interface MultiFieldEntryValue {
  id: string;
  subFieldValues: Record<string, any>;
}
export interface TextFieldTemplate {
  id?: string;
  label: string;
  placeholder: string;
  required: boolean;
  displayOrder: number;
  minLength?: number;
  maxLength?: number;
}

export interface Field {
  id?: number;
  name: string;
  label: string;
  description?: string;
  hint?: string;
  displayOrder: number;
  fieldType: FieldType;
  required: boolean;
  // Role assignment - determines who can fill this field
  role?: string | null;
  // Transient property - whether current user can edit (computed by backend)
  canEdit?: boolean;
  minLength?: number;
  maxLength?: number;
  minEntries?: number;
  maxEntries?: number;
  requiresLabels?: boolean;
  textEntriesPlaceholder?: string;
  minValue?: number;
  maxValue?: number;
  stepValue?: number;
  minRating?: number;
  maxRating?: number;
  minDate?: string;
  maxDate?: string;
  options?: FieldOption[];
  textTemplates?: TextFieldTemplate[];
  subFields?: SubField[];
  // Reporting properties
  showInReport?: boolean;
  reportOrder?: number;
  // Scoring properties
  includeInScoring?: boolean;
  maximumScore?: number;
  // Aggregate properties
  useAggregate?: boolean;
  // Predefined field properties
  predefinedFieldType?: PredefinedFieldType;
  // Section score properties
  scoreSectionId?: number;
  scoreSection?: { id: number; name: string };
}

export interface Section {
  id?: string;
  name: string;
  description: string;
  displayOrder: number;
  role: string | null;
  canEdit: boolean
  includeInReportScore?: boolean;
  fields: Field[];
}

export interface SectionResponseDTO {
  id: number;
  sectionId: number;
  sectionName: string;
  status: SectionStatus;
  canEdit: boolean;
  responses: ResponseDTO[];
}

export interface ResponseDTO {
  id?: number;
  fieldId: number;
  fieldName: string;
  value: any;
}

export interface EvaluationStatusInfo {
  evaluationId: number;
  totalSections: number;
  submittedSections: number;
  allSectionsSubmitted: boolean;
  canComplete: boolean;
}

export interface Template {
  id?: number;
  name: string;
  description?: string;
  version: string;
  active: boolean;
  programmeTypeId?: string;
  programmeType?: {
    id: string;
    name: string;
  };
  createdAt?: string;
  updatedAt?: string;
  sections: Section[];
}
